import { Transition } from '@headlessui/react';
import { Fragment, useContext } from 'react';
import { ControlContext } from 'provider/ControlProvider';
import AreaList from 'assets/data/arealist.json';

export default function AreaButton() {
  const { pinInfo, content, setContent, setPinInfo } =
    useContext(ControlContext);
  console.log('content', content);
  return (
    <Transition
      appear
      show={pinInfo.index !== 0}
      as={Fragment}
      enter='transition-opacity duration-300'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition-opacity duration-150'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <button
        className='w-full md:w-72 absolute text-3xl bottom-0 md:top-28 right-0 md:right-12 h-28 bg-forthColor text-white overflow-hidden shadow-lg drop-shadow-lg flex justify-between item-center border-4 border-zinc-900 hover:border-zinc-200'
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setContent({ index: pinInfo.index, type: 1, url: '' });
          setPinInfo({ index: 0, partNumber: 0, pos: [0, 0, 0] });
        }}
      >
        <img
          src={AreaList[pinInfo.index].src}
          className='h-full w-auto'
          alt={AreaList[pinInfo.index].title}
        />
        <div className='text-white text-lg text-center flex flex-col justify-center items-center w-full h-full space-y-2'>
          <p>{AreaList[pinInfo.index].title}</p>
          <p className='text-xs'>(Click to go into the world)</p>
        </div>
      </button>
    </Transition>
  );
}
